
/**
 * Percentage-Calc 0.0.1
 * https://github.com/abpetkov/percentage-calc
 *
 * Authored by Alexander Petkov
 * https://github.com/abpetkov
 *
 * Copyright 2014, Alexander Petkov
 * License: The MIT License (MIT)
 * http://opensource.org/licenses/MIT
 *
 */

/**
 * Check if number.
 *
 * @param {Number} num
 * @returns {Boolean}
 * @api public
 */

exports.isNumber = function (num) {
  return typeof num === 'number'
}

/**
 * Calculate percentage of a number.
 *
 * @param {Number} perc
 * @param {Number} num
 * @returns {Number} result
 * @api public
 */

exports.of = function (perc, num) {
  if (exports.isNumber(perc) && exports.isNumber(num)) return (perc / 100) * num
}

/**
 * Calculate percentage of a number out ot another number.
 *
 * @param {Number} part
 * @param {Number} target
 * @returns {Number} result
 * @api public
 */

exports.from = function (part, target) {
  if (exports.isNumber(part) && exports.isNumber(target)) return (part / target) * 100
}



// WEBPACK FOOTER //
// ./~/vux/src/components/range/range/lib/lib/percentage-calc.js